export const PolkadotVault = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 264.66 264.66"
  >
    <path
      d="M217.09,132.33a84.76,84.76,0,1,1-84.76-84.76A84.76,84.76,0,0,1,217.09,132.33Z"
      fill="#fff"
    />
    <path
      d="M264.66,132.33A132.33,132.33,0,1,1,132.33,0,132.33,132.33,0,0,1,264.66,132.33ZM132.33,47.57a84.76,84.76,0,1,0,84.76,84.76A84.76,84.76,0,0,0,132.33,47.57Zm-28.24,66A27.75,27.75,0,1,0,131.84,85.8,27.74,27.74,0,0,0,104.09,113.55Zm27.82,14.54h0a11.17,11.17,0,0,0-11.16,11.17v31.6A11.17,11.17,0,0,0,131.91,182h0a11.17,11.17,0,0,0,11.17-11.17v-31.6A11.17,11.17,0,0,0,131.91,128.09Z"
      fill="#e6007a"
    />
  </svg>
);

export default PolkadotVault;
